<div class="snow-container" *ngIf="enabled">
  <div
    *ngFor="let snowflake of snowflakes; trackBy: trackByIndex"
    class="snowflake"
    [style.left.%]="snowflake.left"
    [style.animation-duration.s]="snowflake.animationDuration"
    [style.animation-delay.s]="snowflake.animationDelay"
    [style.font-size.px]="snowflake.size"
    [style.opacity]="snowflake.opacity"
  >
    {{ snowflake.symbol }}
  </div>
</div>

